
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-d5dadf48&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CollectionReport.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CollectionReport.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-d5dadf48!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CollectionReport.vue"),
  /* scopeId */
  "data-v-d5dadf48",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/Reports/CollectionReport.vue
// module id = 725
// module chunks = 0